var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "form-group"]
var hoisted2 = ["class", "checkbox-inline"]
var hoisted3 = ["type", "checkbox"]
var hoisted4 = ["class", "form-group"]
var hoisted5 = ["for", "defaultValue"]
var hoisted6 = ["id", "defaultValue", "class", "form-control input-sm"]
var hoisted7 = ["value", "true"]
var hoisted8 = ["value", "false"]
var __target

module.exports = function description (model) {
elementOpen("div", "edb2e3eb-11c4-4166-94ea-f4be8faad11c", hoisted1)
  elementOpen("div")
    elementOpen("label", "81db62ff-8d66-4259-afd8-a93e6848fce3", hoisted2)
      elementOpen("input", "5e69714c-81ef-4d0e-b29d-8bf5dd30d7a4", hoisted3, "checked", model.required, "onchange", function ($event) {
        var $element = this;
      model.required = this.checked})
      elementClose("input")
      text(" Required \
          ")
    elementClose("label")
  elementClose("div")
elementClose("div")
elementOpen("div", "cfc6edbd-5843-46df-9537-ed716d5607e5", hoisted4)
  elementOpen("label", "a2f119f1-b8d9-4611-a37d-a45031bdfe8c", hoisted5)
    text("Default value")
  elementClose("label")
  elementOpen("select", "9a8ead5d-5906-401e-850c-94fcd67fc609", hoisted6, "value", model.defaultValue, "onchange", function ($event) {
    var $element = this;
  model.defaultValue = this.value ? this.value : null})
    elementOpen("option")
    elementClose("option")
    elementOpen("option", "b5d64adf-d72e-4694-9d22-8171832eb4b2", hoisted7, "selected", model.defaultValue === true ? 'selected' : null)
      text("true")
    elementClose("option")
    elementOpen("option", "fda8e2e7-c9f8-4267-8c26-7a6cb4ce7656", hoisted8, "selected", model.defaultValue === false ? 'selected' : null)
      text("false")
    elementClose("option")
  elementClose("select")
elementClose("div")
}
